import { toHandicap } from '../../../../../../../contrib/Utils/toHandicap';
import { IAdminFlight } from '../../../../../../../store/admin/eventFlights/store';

export const parseHandicap = ({ handicapLower, handicapUpper }: IAdminFlight) =>
  !!handicapLower && !!handicapUpper
    ? `${toHandicap(handicapLower)} to ${toHandicap(handicapUpper)}`
    : !!handicapLower
    ? `Greater than ${toHandicap(handicapLower)}`
    : !!handicapUpper
    ? `Less than ${toHandicap(handicapUpper)}`
    : '--';
